import type { CanvasRetrieve, User } from '@openapi'

export interface GetCanvasesParams {
  search?: string
  account__id?: string
  instance_id?: string
  is_draft?: boolean
  is_editable?: boolean
  is_section?: boolean
  is_template?: boolean
  is_default?: boolean
  ordering?: string
  page?: number
  page_size?: number
  section_ids?: string[]
  tags__in?: string[]
  tags__not_in?: string
  id__in?: string
  access_type?: string
  template__id?: string
}

export interface CanvasMetadataRetrieve {
  canvas_id: CanvasRetrieve['id']
  config: Record<string, any> & { presentation_component_metadata: Record<string, any> }
  owner_id: User['id']
}

export enum CanvasesViewsTypes {
  SAVED = 'saved',
  TEMPLATES = 'templates',
}

export enum CanvasStatus {
  READY = 'ready',
  DRAFT = 'draft',
}

export type CanvasType = 'template' | 'section-template' | 'section' | 'canvas' | 'block'

export interface CanvasIndicator {
  icon: string
  key: string
  text: string
  type?: 'default' | 'primary' | 'info' | 'success' | 'warning' | 'error'
  background_color?: string
  color?: string
  tooltip_text?: string
}
